import settings from '@config/settings'
import { GuardianLogo } from '@images'
import { LoginStatuses, paths, useAuth } from 'mmfintech-backend-api'
import { Link } from 'react-router-dom'

function BrandLogo() {
  const userStatus = useAuth()
  const isLoggedIn = userStatus === LoginStatuses.LOGGED_IN

  const logoImage = <img src={GuardianLogo} alt='Logo' className='brand-logo-image' />

  return (
    <div className='brand-logo-wrapper'>
      {isLoggedIn ? <Link to={paths.dashboard()}>{logoImage}</Link> : <a href={settings.landingPageUrl}>{logoImage}</a>}
    </div>
  )
}

export default BrandLogo
